import { el , appendAll} from './layout';

export function progressBar(progress: unknown, target = 100): HTMLElement {
  let scored = 0;
  let stage = '';
  if (progress && typeof progress === 'object') {
    const p = progress as { scored?: number; stage?: string };
    scored = Number(p.scored) || 0;
    stage = String(p.stage || '');
  } else if (typeof progress === 'string') {
    try {
      const p = JSON.parse(progress) as { scored?: number; stage?: string };
      scored = Number(p.scored) || 0;
      stage = String(p.stage || '');
    } catch {
      /* ignore */
    }
  }
  const pct = Math.max(0, Math.min(100, Math.round((scored / Math.max(1, target)) * 100)));
  const wrap = el('div');
  const bar = el('div', { className: 'progress' }, [
    el('span', { style: `width:${pct}%` }),
  ]);
  wrap.appendChild(bar);
  appendAll(wrap, el('div', {
      className: 'muted',
      style: 'margin-top:6px;font-size:12px',
      text: stage ? `${stage} · ${scored}/${target}` : `${scored}/${target}`,
    }),
  );
  return wrap;
}

export function parseProgress(progress: unknown): {
  stage: string;
  found: number;
  kept: number;
  scored: number;
} {
  const empty = { stage: '', found: 0, kept: 0, scored: 0 };
  try {
    const p =
      typeof progress === 'string'
        ? (JSON.parse(progress) as Record<string, unknown>)
        : (progress as Record<string, unknown>);
    if (!p || typeof p !== 'object') return empty;
    return {
      stage: String(p.stage || ''),
      found: Number(p.found) || 0,
      kept: Number(p.kept) || 0,
      scored: Number(p.scored) || 0,
    };
  } catch {
    return empty;
  }
}
